import { useEffect } from "react";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Features from "@/components/Features";
import HowItWorks from "@/components/HowItWorks";
import Product3DViewer from "@/components/Product3DViewer";
import Specs from "@/components/Specs";
import BuySection from "@/components/BuySection";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import Marquee from "@/components/Marquee";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";

const ProductPage = () => {
  const [params, setParams] = useSearchParams();

  useEffect(() => {
    if (params.get("canceled") === "true") {
      toast.info("Checkout canceled", { description: "Your cart is still saved. Continue when ready." });
      params.delete("canceled");
      setParams(params, { replace: true });
    }
  }, [params, setParams]);

  return (
    <main data-testid="product-page">
      <Nav />
      <Hero />
      <Marquee />
      <Features />
      <HowItWorks />
      <Product3DViewer />
      <Specs />
      <BuySection />
      <Footer />
      <CartDrawer />
    </main>
  );
};

export default ProductPage;
